import Cookies from "universal-cookie";
import { get } from "psl";

import { formatHeaders, handleErrors } from "utils/Api";
import rootURL from "utils/RootURL";
import i18n from "../i18n";

import history from "components/common/navigation/AppHistory";

const { localStorage } = global.window;

const Auth = {};

const setCookies = (logged, token) => {
  const domain = get(window.location.hostname);

  const cookies = new Cookies();
  cookies.set("is_logged", logged, { path: "/", domain });
  cookies.set("token", token, { path: "/", domain });
};

const onAuthSuccedeed = (json) => {
  if (!json.authentication && !json.errorType) {
    Auth.setSession("true", json.token, json.avatar_url);

    localStorage.editor_authorised = "false";
    if (
      json.organization_uuid &&
      json.organization_uuid.length > 0 &&
      json.orga_enabled
    ) {
      localStorage.editor_authorised = "true";
    }
  }

  return json;
};

Auth.logout = (token) =>
  fetch(rootURL("/api/user/v2/signout"), {
    method: "DELETE",
    headers: formatHeaders(token),
  })
    .then(handleErrors)
    .then(() => {
      Auth.setSession("false");
      localStorage.editor_authorised = "false";
      return { isLoggedIn: false, isEditorAuth: false };
    })
    .catch((e) => ({ error: e.message }));

Auth.login = (email, password, token) =>
  fetch(rootURL("/api/user/v2/signin"), {
    method: "POST",
    headers: formatHeaders(token),
    body: JSON.stringify({
      email,
      password,
      force: true,
    }),
  })
    .then(handleErrors)
    .then(onAuthSuccedeed)
    .catch((e) => ({ error: e.message }));

Auth.confirmLogin = (authenticationData, otpToken, token) => {
  const data = {
    authentication_data: authenticationData,
    otp_token: otpToken,
  };

  return fetch(rootURL("/api/user/v2/signin"), {
    method: "POST",
    headers: formatHeaders(token),
    body: JSON.stringify(data),
  })
    .then(handleErrors)
    .then(onAuthSuccedeed)
    .catch((e) => ({ error: e.errorDetails.message }));
};

Auth.fbLogin = (userId, accessToken, token) =>
  fetch(rootURL("/api/user/v2/fb_signin"), {
    method: "POST",
    headers: formatHeaders(token),
    body: JSON.stringify({
      user_id: userId,
      access_token: accessToken,
      force: true,
    }),
  })
    .then(handleErrors)
    .then(onAuthSuccedeed)
    .catch((e) => ({ error: e.message }));

Auth.register = (
  email,
  password,
  firstName,
  lastName,
  countryUuid,
  lang,
  custom1,
  custom2,
  token,
) =>
  fetch(rootURL("/api/user/v3/create"), {
    method: "POST",
    headers: formatHeaders(token),
    body: JSON.stringify({
      email,
      password,
      first_name: firstName,
      last_name: lastName,
      country_uuid: countryUuid,
      lang,
      custom_1: custom1,
      custom_2: custom2,
      locale: i18n.language || i18n.options.fallbackLng[0],
    }),
  })
    .then(handleErrors)
    .then((json) => {
      Auth.setSession("true", json.token, json.avatar_url);

      return json;
    })
    .catch((e) => ({ error: e.message }));

Auth.loggedIn = () => localStorage.logged === "true";

Auth.editorAuth = () => localStorage.editor_authorised === "true";

Auth.getToken = () => localStorage.token || "";

Auth.getAvatar = () => localStorage.avatar_url || "";

Auth.setSession = (logged, token, avatarUrl) => {
  localStorage.logged = logged;
  localStorage.token = token || "";
  localStorage.avatar_url = avatarUrl || "";
  setCookies(logged, token);
};

Auth.setEditorAuth = (orgaUuid, orgaEnabled) => {
  if (orgaUuid && orgaUuid.length > 0 && orgaEnabled) {
    localStorage.editor_authorised = "true";
  }
};

Auth.checkAutoSignIn = (location, setSession) => {
  const token = new URLSearchParams(location.search).get("token");

  if (token && !Auth.loggedIn()) {
    Auth.setSession("true", token, null);
    setSession(token);

    history.push(location.pathname);
  }
};

export default Auth;
